import { Banner, Heading, List, Modal } from "@shopify/polaris"
import { useContext } from "react"
import { useFirestoreDataUpdate } from "../hooks/useFirestoreDataUpdate"
import { GlobalStateContext } from "./providers/GlobalStateProvider"
import kopyLogo from "../assets/kopy-logo-square.png"
import { useTranslation } from "react-i18next"

const Tutorial = () => {
	const { state, dispatch } = useContext(GlobalStateContext)
	const { t } = useTranslation()
	const updateFirestoreUserData = useFirestoreDataUpdate()

	const dismiss = () => {
		updateFirestoreUserData({ hasTutorialDismissed: true })
		dispatch({ hasTutorialDismissed: true })
	}

	return (
		<Modal
			status="info"
			title={
				<div
					style={{
						display: "flex",
						alignItems: "center",
						gap: "0.5rem",
					}}
				>
					<img
						style={{
							width: "1.875rem",
							height: "1.875rem",
							borderRadius: "0.3125rem",
						}}
						src={kopyLogo}
					/>
					<span>
						{t("components.tutorial.welcome_to_kopy")}{" "}
						<span role="img" aria-label="wave">
							👋
						</span>
					</span>
				</div>
			}
			open={!state.hasTutorialDismissed}
			onClose={dismiss}
		>
			<div style={{ padding: "1rem 1rem 2rem 1rem" }}>
				<div style={{ marginBottom: "1rem" }}>
					<Heading>
						{t(
							"components.tutorial.if_this_is_your_first_time_using_kopy",
						)}
					</Heading>
				</div>

				<List type="number">
					<List.Item>
						{t(
							"components.tutorial.click_on_the_and_quot_import_a_single_product_and_quot_button_below",
						)}
					</List.Item>
					<List.Item>
						{t(
							"components.tutorial.simply_enter_the_url_of_the_product_you_want_and_click_import",
						)}
					</List.Item>
					<List.Item>
						{t(
							"components.tutorial.you_will_then_be_able_to_edit_some_details_like_the_title_description_and_the_price",
						)}
					</List.Item>
					<List.Item>
						{t(
							"components.tutorial.finally_click_and_quot_import_product_and_quot_and_voila_it_and_apos_s_that_easy",
						)}
					</List.Item>
				</List>
			</div>
		</Modal>
	)
}

export default Tutorial
